import React, { PureComponent } from 'react'
import { Header, Button, Modal, List } from 'semantic-ui-react'
import firebase from '../../../config/firebase'

class ListDriverInSegmentModal extends PureComponent {

  onRemove = async (driverUID) => {
    const driverObj = {}
    driverObj[`/deliverers/${driverUID}/driver_segment`] = null
    await firebase.database().ref().update(driverObj)
  }

  renderNoDrivers = () => {
    return <Header size="small">No data available</Header>
  }

  renderDrivers = () => {
    const { drivers } = this.props

    return drivers.map((driver, index) => (
      <List divided verticalAlign='middle' key={driver.driverUID}>
        <List.Item>
          <List.Content floated='right'>
            <Button icon="remove" color="red" onClick={() => this.onRemove(driver.driverUID)} />
          </List.Content>
          <List.Content>
            <List.Header>
              {` ${index+1}. ${driver.family_name} ${driver.first_name}`}
            </List.Header>
          </List.Content>
        </List.Item>
      </List>
    ))
  }

  render() {
    const { open, driverSegment, drivers, onClose } = this.props

    return (
      <Modal open={open} size="small" style={{ marginTop: 0 }}>
        <Modal.Header content={driverSegment.name} />
        <Modal.Content>
          {
            drivers.length === 0 ? this.renderNoDrivers() : this.renderDrivers()
          }
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default ListDriverInSegmentModal


// WEBPACK FOOTER //
// ./src/components/drivers/views/listDriverInSegmentModal.js